import { WifiOff } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import type { AgentDto } from '@/api/control/missionImpactAPI.schemas'
import { useLanguage } from '@/contexts/LanguageContext'

interface AgentOfflineProfileAlertProps {
  agent?: AgentDto
}

/**
 * Banner shown on a profile whose target's agent is offline: nothing syncs until the agent is back.
 * Returns null unless the agent is offline.
 */
export function AgentOfflineProfileAlert({ agent }: AgentOfflineProfileAlertProps) {
  const { t } = useLanguage()

  if (agent?.healthState !== 'Offline') {
    return null
  }

  const since = agent.offlineSinceUtc ? new Date(agent.offlineSinceUtc).toLocaleString() : '-'

  return (
    <Alert variant="destructive">
      <WifiOff className="h-4 w-4" />
      <AlertTitle>{t.agents.agentOffline.title}</AlertTitle>
      <AlertDescription>
        {t.agents.agentOffline.profileDescription.replace('{agent}', agent.name).replace('{time}', since)}
      </AlertDescription>
    </Alert>
  )
}
